import React from 'react';
import PropTypes from 'prop-types';
import PhoneNumberInput from 'react-phone-number-input';
import { connect } from 'react-redux';

import Flow from 'flow';
import Loading from 'flow/components/ui-components/Loading';
import BaseInput from 'flow/components/ui-components/BaseInput';

import { getOwnExtensionKey, getOwnContact } from 'flow/selectors/selectors';
import { getCountryCode } from 'flow/utils/extension-utils';
import AppContext from 'flow/contexts/app-context';

const InputComponent = React.forwardRef(function InputComponent(props, ref) {
    const { value, onChange } = props;
    return (
        <BaseInput
            value={value}
            onChange={onChange}
            ref={ref}
            noMarginTop={true}
        />
    );
});

InputComponent.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};

class InviteColleague extends React.PureComponent {
    static propTypes = {
        number: PropTypes.string,
        updateNumber: PropTypes.func.isRequired,
        contact: Flow.PropTypes.contactDTO,
        loggedInCustomer: Flow.PropTypes.customerDTO,
    };

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            number: props.number ? '' : props.number,
        };
    }

    handleChange = (number) => {
        this.setState({ number });
        this.props.updateNumber(number);
    };

    render() {
        const { contact, loggedInCustomer } = this.props;
        const { number } = this.state;
        const { i18next } = this.context;

        if (!loggedInCustomer) {
            return <Loading />;
        }

        const countryCode = getCountryCode(
            contact,
            loggedInCustomer,
        ).toUpperCase();

        return (
            <>
                <div className="mb-1">
                    {i18next.t('InviteColleagues.TokenField.Title')}
                </div>

                <PhoneNumberInput
                    placeholder={i18next.t('InviteColleagues.TokenField.Input')}
                    value={number}
                    defaultCountry={countryCode}
                    onChange={this.handleChange}
                    countries={[
                        'SE',
                        'DK',
                        'NO',
                        'GB',
                        'FI',
                        'BR',
                        'IT',
                        'ES',
                        'PL',
                        'BE',
                        'GR',
                        'BG',
                        'CH',
                        'IL',
                        'LV',
                        'LT',
                        'AU',
                        'EE',
                        'CL',
                        'PE',
                        'FO',
                    ]}
                    inputComponent={InputComponent}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { customer } = state;

    const extensionKey = getOwnExtensionKey(state);
    const contact = getOwnContact(state);
    const loggedInCustomer = customer.get(extensionKey);

    return { contact, loggedInCustomer };
};

export default connect(mapStateToProps)(InviteColleague);
